import cache from 'memory-cache';

export function setCache(key, value) {
	cache.put(key, value, 604800);
}

export function getCache(key) {
	return cache.get(key);
}
